import { useEffect, useState } from 'react';
import { Button, Text, Title, message } from 'ui';
import { ForgotPasswordForm } from '../components';
import { useRequestResetMutation } from '../queries';

type P = {
  email?: string;
  onNavigateToPrimaryLogin: () => Promise<void>;
  onResetSuccess: () => void;
};

const ForgotPassword = ({ email, onNavigateToPrimaryLogin, onResetSuccess }: P) => {
  const {
    data: resetPasswordData,
    error: resetPasswordError,
    isPending: isLoadingResetPasswordRequest,
    mutate: resetPassword,
  } = useRequestResetMutation();
  const [isResetSuccess, setIsResetSuccess] = useState(false);

  const onSubmit = ({ email: resetEmail }: { email: string }) => {
    resetPassword({ domain: window.location.hostname, email: resetEmail });
  };

  useEffect(() => {
    if (resetPasswordData) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- TODO: fix later
      setIsResetSuccess(true);
    }
  }, [resetPasswordData]);

  useEffect(() => {
    if (resetPasswordError) {
      if (resetPasswordError.response && resetPasswordError.response.status >= 500) {
        message.error('Something went wrong. Please, try again later.');
      } else {
        // eslint-disable-next-line react-hooks/set-state-in-effect -- TODO: fix later
        setIsResetSuccess(true);
      }
    }
  }, [resetPasswordError]);

  return (
    <>
      <Title level={1} marginBottom>
        Forgot password
      </Title>
      {isResetSuccess ? (
        <>
          <Text className="onboarding-forgot-password__reset-request-message">resetRequestSuccess</Text>
          <Button
            block
            onClick={() => {
              onResetSuccess();
            }}
          >
            Back to Log in
          </Button>
        </>
      ) : (
        <div className="onboarding-forgot-password__form-wraper">
          <ForgotPasswordForm
            email={email}
            loading={isLoadingResetPasswordRequest}
            onNavigateToPrimaryLogin={async () => {
              await onNavigateToPrimaryLogin();
            }}
            onSubmit={onSubmit}
          />
        </div>
      )}
    </>
  );
};

export default ForgotPassword;
